import { Theme } from "@mui/material/styles";
import type { DataGridProComponents } from "@mui/x-data-grid-pro/themeAugmentation";

export const dataGridCustomizations: DataGridProComponents<Theme> &
  DataGridProComponents<Theme> = {
  MuiDataGrid: {
    styleOverrides: {
      root: {
        boxShadow:
          "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
        overflow: "visible",
        "&.services": {
          ".MuiDataGrid-virtualScroller": {
            width: "calc(100vw - 322px)",
          },
          ".MuiDataGrid-columnHeaders": {
            display: "none",
          },
          ".MuiDataGrid-row": {
            "&.Mui-selected": {
              backgroundColor: "#eef7fe !important",
              ".MuiDataGrid-cell": {
                "&.description": {
                  background: "#eef7fe !important",
                },
                "&.select": {
                  background: "#eef7fe !important",
                },
              },
            },
            "&:hover": {
              background: "#f5f5f5",
              ".MuiDataGrid-cell": {
                "&.description": {
                  background: "#f5f5f5",
                },
                "&.select": {
                  background: "#f5f5f5",
                },
              },
            },
          },
          ".MuiDataGrid-cell": {
            height: "auto !important",
            padding: "8px",
            "&.description": {
              position: "sticky",
              background: "white",
              left: "54px",
            },
            "&.select": {
              position: "sticky",
              background: "white",
              left: 0,
            },
          },
        },
        "&.offers": {
          ".MuiDataGrid-row": {
            cursor: "pointer",
          },
        },
        "&.unloading, &.packing": {
          ".MuiDataGrid-footerContainer": {
            paddingTop: 0,
            paddingBottom: 0,
          },
          "&.sidebar-open": {
            ".MuiDataGrid-footerContainer": {
              paddingTop: "8px",
              paddingBottom: 0,
              minHeight: "115px",
            },
          },
          ".MuiDataGrid-columnHeader[data-field='__filler__']": {
            boxShadow: "none",
          },
          ".MuiDataGrid-columnHeaderTitleContainer": {
            whiteSpace: "break-spaces",
          },
          ".MuiDataGrid-columnHeader--last": {
            overflow: "visible",
          },
          ".partial-column-header": {
            padding: "0 0 0 26px",
          },
          ".MuiInputBase-sizeSmall": {
            fontSize: "14px",
            marginTop: "3px !important",
          },
          ".MuiDataGrid-cell": {
            height: "auto !important",
            padding: "8px",
            lineHeight: "40px",
            "&.actions": {
              position: "sticky",
              background: "white",
              right: "0",
              zIndex: 3,
              borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
              boxShadow: "-1px 0px 2px rgba(0, 0, 0, 0.12)",
              padding: "8px 8px 8px 16px !important",
            },
            "&.MuiDataGrid-cellEmpty": {
              padding: 0,
            },
          },
          "&.lite-tms-tablet": {
            "--DataGrid-rowHeight": "36px",
            ".MuiDataGrid-row": {
              height: "36px !important",
              minHeight: "36px !important",
              maxHeight: "36px !important",
              overflow: "hidden",
            },
            ".MuiDataGrid-cell": {
              height: "36px !important",
              minHeight: "36px !important",
              maxHeight: "36px !important",
              padding: "2px 6px !important",
              lineHeight: "1.25 !important",
              fontSize: "0.8125rem",
              alignItems: "center",
              display: "flex",
              overflow: "hidden",
              boxSizing: "border-box",
            },
            ".MuiDataGrid-columnHeader": {
              height: "36px !important",
              minHeight: "36px !important",
              maxHeight: "36px !important",
              padding: "2px 6px !important",
            },
            ".MuiDataGrid-columnHeaders": {
              minHeight: "36px !important",
              maxHeight: "36px !important",
            },
            ".MuiDataGrid-columnHeaderTitle": {
              fontSize: "0.8125rem",
              fontWeight: 500,
            },
            ".partial-column-header": {
              padding: "0 0 0 6px !important",
            },
            ".MuiDataGrid-footerContainer": {
              minHeight: "40px !important",
              paddingTop: "0 !important",
              paddingBottom: "0 !important",
            },
            ".MuiDataGrid-cell .MuiChip-root": {
              height: 22,
              fontSize: "0.75rem",
              "& .MuiChip-label": {
                px: 0.75,
              },
            },
            ".MuiDataGrid-cell .MuiIconButton-root": {
              padding: 4,
            },
            ".lite-tms-pinned-column": {
              position: "sticky",
              left: 0,
              zIndex: 3,
              backgroundColor: "white",
              borderRight: "1px solid rgba(0, 0, 0, 0.12)",
              boxShadow: "2px 0 2px rgba(0, 0, 0, 0.08)",
            },
            ".lite-tms-pinned-column-header": {
              position: "sticky",
              left: 0,
              zIndex: 4,
              backgroundColor: "white",
              borderRight: "1px solid rgba(0, 0, 0, 0.12)",
              boxShadow: "2px 0 2px rgba(0, 0, 0, 0.08)",
            },
            ".MuiDataGrid-row:hover .lite-tms-pinned-column": {
              backgroundColor: "#f5f5f5",
            },
            ".lite-tms-checkbox-header": {
              padding: "0 !important",
              overflow: "visible",
            },
            ".lite-tms-checkbox-header .MuiDataGrid-columnHeaderTitleContainer":
              {
                overflow: "visible",
              },
            ".lite-tms-checkbox-header .MuiDataGrid-columnHeaderTitleContainerContent":
              {
                overflow: "visible",
              },
            ".lite-tms-checkbox-cell": {
              padding: "0 !important",
              overflow: "visible",
              justifyContent: "center",
            },
            ".lite-tms-checkbox-header .MuiCheckbox-root, .lite-tms-checkbox-cell .MuiCheckbox-root":
              {
                overflow: "visible",
              },
            ".lite-tms-status-header": {
              padding: "2px 8px !important",
              overflow: "visible",
            },
            ".lite-tms-status-header .MuiDataGrid-columnHeaderTitleContainer": {
              overflow: "visible",
            },
            ".lite-tms-status-cell": {
              padding: "2px 8px !important",
              overflow: "hidden",
              justifyContent: "flex-start",
            },
            ".lite-tms-status-cell .MuiChip-root": {
              maxWidth: "none",
            },
            ".MuiDataGrid-virtualScroller": {
              overflowX: "auto",
            },
            ".MuiDataGrid-scrollbar--horizontal": {
              display: "block",
            },
            ".MuiDataGrid-main--hasScrollY .MuiDataGrid-cell.actions, .MuiDataGrid-main--hasScrollY .MuiDataGrid-columnHeader.actions":
              {
                right: "var(--DataGrid-scrollbarSize, 17px)",
              },
            ".MuiDataGrid-cell.actions": {
              overflow: "visible !important",
              position: "sticky",
              right: 0,
              zIndex: 5,
              flexShrink: 0,
              backgroundColor: "white",
              borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
              boxShadow: "-2px 0 4px rgba(0, 0, 0, 0.08)",
              padding: "2px 4px !important",
            },
            ".MuiDataGrid-columnHeader.actions": {
              overflow: "visible !important",
              position: "sticky",
              right: 0,
              zIndex: 6,
              flexShrink: 0,
              backgroundColor: "white",
              borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
              boxShadow: "-2px 0 4px rgba(0, 0, 0, 0.08)",
              padding: "2px 4px !important",
            },
            ".MuiDataGrid-row:hover .MuiDataGrid-cell.actions": {
              backgroundColor: "#f5f5f5",
            },
            ".MuiDataGrid-cell.actions .MuiIconButton-root": {
              padding: 2,
              width: 28,
              height: 28,
              minWidth: 28,
            },
            "&.no-sticky": {
              ".lite-tms-pinned-column, .lite-tms-pinned-column-header": {
                position: "static",
                left: "auto",
                boxShadow: "none",
                borderRight: "none",
              },
              ".MuiDataGrid-cell.actions, .MuiDataGrid-columnHeader.actions": {
                position: "static",
                right: "auto",
                boxShadow: "none",
                borderLeft: "none",
              },
            },
          },
        },
        "&.whs": {
          ".MuiDataGrid-row": {
            "&:hover": {
              ".MuiDataGrid-cell": {
                "&.sticky-checkbox, &.sticky-column": {
                  backgroundColor: "#f5f5f5",
                },
              },
            },
            "&.Mui-selected": {
              "&:hover": {
                ".MuiDataGrid-cell": {
                  backgroundColor: "#f5f5f5 !important",
                },
              },
            },
          },
          ".MuiDataGrid-cell": {
            "&.sticky-checkbox": {
              position: "sticky",
              left: "0",
              backgroundColor: "white",
              zIndex: 3,
            },
            "&.sticky-column": {
              position: "sticky",
              left: "50px",
              backgroundColor: "white",
              zIndex: 2,
            },
          },
          ".MuiDataGrid-columnHeader": {
            "&.sticky-checkbox-header": {
              position: "sticky",
              left: "0",
              backgroundColor: "white",
              zIndex: 5,
            },
            "&.sticky-column-header": {
              position: "sticky",
              left: "50px",
              backgroundColor: "white",
              zIndex: 4,
            },
          },
        },
        "&.whs-readonly": {
          ".MuiDataGrid-row": {
            "&:hover": {
              ".MuiDataGrid-cell": {
                "&.sticky-column": {
                  backgroundColor: "#f5f5f5",
                },
              },
            },
            "&.Mui-selected": {
              "&:hover": {
                backgroundColor: "#f5f5f5 !important",
              },
            },
          },
          ".MuiDataGrid-cell": {
            "&.sticky-column": {
              position: "sticky",
              left: "0",
              backgroundColor: "white",
              zIndex: 2,
            },
          },
          ".MuiDataGrid-columnHeader": {
            "&.sticky-column-header": {
              position: "sticky",
              left: "0",
              backgroundColor: "white",
              zIndex: 4,
            },
          },
        },
        "&.tms": {
          ".MuiDataGrid-row": {
            "&:hover": {
              ".MuiDataGrid-cell": {
                "&.sticky-checkbox, &.sticky-commodity, &.sticky-id": {
                  backgroundColor: "#f5f5f5",
                },
              },
            },
            "&.Mui-selected": {
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            },
          },
          ".MuiDataGrid-cell": {
            "&.sticky-checkbox": {
              position: "sticky",
              left: "0",
              backgroundColor: "white",
              zIndex: 3,
            },
            "&.sticky-commodity": {
              position: "sticky",
              left: "50px",
              backgroundColor: "white",
              zIndex: 2,
            },
            "&.sticky-id": {
              position: "sticky",
              left: "230px",
              backgroundColor: "white",
              zIndex: 2,
            },
          },
          ".MuiDataGrid-columnHeader": {
            "&.sticky-checkbox-header": {
              position: "sticky",
              left: "0",
              backgroundColor: "white",
              zIndex: 5,
            },
            "&.sticky-commodity-header": {
              position: "sticky",
              left: "50px",
              backgroundColor: "white",
              zIndex: 4,
            },
            "&.sticky-id-header": {
              position: "sticky",
              left: "230px",
              backgroundColor: "white",
              zIndex: 4,
            },
          },
        },
        "&.packing": {
          ".MuiDataGrid-topContainer": {
            paddingTop: "84px",
            height: "84px",
          },
          ".MuiDataGrid-columnHeaderTitleContainerContent": {
            overflow: "visible",
          },
          ".MuiDataGrid-columnHeaders": {
            position: "absolute",
            top: "28px",
          },
          ".MuiDataGrid-columnHeader": {
            "&.actions": {
              "&:before": {
                position: "absolute",
                left: "-1px",
                top: "-28px",
                content: `""`,
                height: "28px",
                width: "calc(100% + 1px)",
                background: "white",
                borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
                boxShadow: "-1px 0px 2px rgba(0, 0, 0, 0.12)",
              },
            },
          },
          "&.tabbed.lite-tms-tablet, &.lite-tms-tablet": {
            ".MuiDataGrid-topContainer": {
              paddingTop: "56px",
              height: "56px",
            },
            ".MuiDataGrid-columnHeaders": {
              top: "20px",
            },
            ".MuiDataGrid-columnHeader.actions:before": {
              display: "block",
              top: "-20px",
              height: "20px",
            },
            ".MuiDataGrid-scrollbar--vertical": {
              top: "var(--DataGrid-topContainerHeight)",
            },
          },
        },
        "&.tabbed": {
          ".MuiDataGrid-scrollbar--vertical": {
            top: "calc(var(--DataGrid-topContainerHeight) + 28px)",
            height:
              "calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-topContainerHeight) - 17px - var(--DataGrid-bottomContainerHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))",
          },
        },
        "&.shipping": {
          ".MuiDataGrid-row": {
            cursor: "pointer",
          },
          ".MuiDataGrid-main": {
            tableLayout: "fixed",
          },
          ".MuiDataGrid-columnHeaderTitleContainer": {
            whiteSpace: "break-spaces",
          },
        },
      },
      cell: {
        "&:focus, &:focus-within": {
          outline: 0,
        },
        "&.last_login": {
          whiteSpace: "normal !important",
          overflow: "visible !important",
          wordBreak: "break-word",
          lineHeight: "1.75",
        },
      },
      columnSeparator: {
        display: "none",
      },
      iconButtonContainer: {
        display: "none",
      },
      selectedRowCount: {
        display: "none",
      },
      columnHeader: {
        "&:focus": {
          outline: 0,
        },
        "&.MuiDataGrid-columnHeader": {
          fontWeight: "500",
        },
        "&.MuiDataGrid-columnHeader--sorted": {
          "& svg": {
            transform: "rotate(180deg)",
          },
          "&[aria-sort='descending']": {
            "& svg": {
              transform: "rotate(0)",
            },
          },
        },
      },
      row: {
        "&.Mui-selected": {
          backgroundColor: "white !important",
        },
      },
    },
  },
};
